import { gql } from 'graphql-request';

import { accountMutations } from 'shared/graphql/mutations/account';
import { shoppingCartWishlistMutations } from 'shared/graphql/mutations/shopping_cart_and_wishlist';
import { userAudiobookMutations } from 'shared/graphql/mutations/user_audiobooks';
import { userCollectionMutations } from 'shared/graphql/mutations/user_collections';
import { userReviewMutations } from 'shared/graphql/mutations/user_reviews';

const createUserReferralLink = gql`
  mutation CreateUserReferralLink($audiobookId: ID!) {
    createUserReferralLink(audiobookId: $audiobookId) {
      url
    }
  }
`;

const createUserNotificationView = gql`
  mutation CreateUserNotificationView($notification: UserNotificationViewNotification!) {
    createUserNotificationView(notification: $notification) {
      userNotificationView {
        id
      }
    }
  }
`;

const followBookClub = gql`
  mutation FollowBookClub($id: ID!) {
    followBookClub(id: $id) {
      success
    }
  }
`;

const unfollowBookClub = gql`
  mutation UnfollowBookClub($id: ID!) {
    unfollowBookClub(id: $id) {
      success
    }
  }
`;

const followPerson = gql`
  mutation FollowPerson($slug: String!, $source: UserPersonFollowSource) {
    followPerson(slug: $slug, source: $source) {
      success
    }
  }
`;

const followTag = gql`
  mutation FollowTag($tagId: ID!) {
    followTag(tagId: $tagId) {
      userTag {
        id
      }
    }
  }
`;

const markAudiobookVisited = gql`
  mutation MarkAudiobookVisited($audiobookId: ID!) {
    markAudiobookVisited(audiobookId: $audiobookId) {
      success
    }
  }
`;

const unfollowPerson = gql`
  mutation UnfollowPerson($slug: String!, $source: UserPersonFollowSource) {
    unfollowPerson(slug: $slug, source: $source) {
      success
    }
  }
`;

const unfollowTag = gql`
  mutation UnfollowTag($tagId: ID!) {
    unfollowTag(tagId: $tagId) {
      userTag {
        id
      }
    }
  }
`;

export const graphQLMutations = {
  createUserNotificationView,
  createUserReferralLink,
  followBookClub,
  followPerson,
  followTag,
  markAudiobookVisited,
  unfollowBookClub,
  unfollowPerson,
  unfollowTag,
  ...accountMutations,
  ...shoppingCartWishlistMutations,
  ...userAudiobookMutations,
  ...userCollectionMutations,
  ...userReviewMutations,
};
